/**
 * Builds the page meta for a route's robots directive, leaving the meta empty when the route declares none.
 *
 * @param {Object} route - The matched route, whose meta may carry a robots directive.
 * @returns {Object} - A page meta object holding the robots tag, or one with an empty meta map.
 */
export function buildRouteRobotsMeta(route) {
    return {
        meta: route.meta?.robots ? {
            robots: {
                name: 'robots',
                content: route.meta.robots
            }
        } : {}
    };
}
